export const FETCH_AIRPORTS = 'FETCH_AIRPORTS'
export const fetchAirports = (data) => ({
  type: FETCH_AIRPORTS,
  payload: data,
})
